console.log("redesign.js loaded");

let cartItems = [], pdpQty = 1;

// ===== V11: menú móvil + WhatsApp + scroll a secciones =====
function toggleMenu() { 
  var m = document.getElementById('nav-links'); 
    if (m) m.classList.toggle('open'); 
  }

function closeMenu() { 
  var m = document.getElementById('nav-links'); 
  if (m) m.classList.remove('open'); 
}

function goWhatsApp() { 
  window.open('https://wa.me/56954135696', '_blank'); 
}

function goHistory() { 
  nav('home'); setTimeout(function () { 
    var h = document.querySelector('.history-section'); 
      if (h) h.scrollIntoView({ 
        behavior: 'smooth', block: 'start' 
      }); 
    }, 120
  ); 
}

function goPacks() { 
  nav('home'); 
  setTimeout(function () { 
    var p = document.getElementById('home-packs'); 
    if (p) p.scrollIntoView({ 
      behavior: 'smooth', block: 'start' 
    }); 
  }, 120); 
}


function nav(id) {
  document.querySelectorAll('.page').forEach(p => p.classList.remove('active'));
  document.getElementById('pg-' + id).classList.add('active');
  document.querySelectorAll('.nav-links a').forEach(a => a.classList.remove('active'));
  const nl = document.getElementById('nl-' + id);
    if (nl) nl.classList.add('active');
    window.scrollTo(0, 0);
    if (id === 'carrito') renderCart();
    if (id === 'checkout') renderCheckout();
}

function addCart(name, price, img) {
  cartItems.push({ name, price, img, qty: 1 });
  document.getElementById('cart-count').textContent = cartItems.length;
  document.getElementById('cart-notif-txt').textContent = name + ' · ' + price;
  const n = document.getElementById('cart-notif');
    n.classList.add('show');
    setTimeout(() => n.classList.remove('show'), 2800);
}

function renderCart() {
  const list = document.getElementById('cart-items-list');
  const empty = document.getElementById('cart-empty-msg');
  const wrap = document.getElementById('cart-content-wrap');
    if (!cartItems.length) { 
      empty.style.display = 'block'; 
      wrap.style.display = 'none'; 
      return; 
    }
    empty.style.display = 'none'; wrap.style.display = 'grid';
    list.innerHTML = cartItems.map((item, i) => `
    <div class="cart-item">
      <img class="cart-item-img" src="${item.img}" alt="${item.name}">
      <div>
        <div class="cart-item-name">${item.name}</div>
        <div class="cart-item-sub">Pieza completa · Hecha a mano</div>
        <div class="cart-item-qty-ctrl">
          <button class="qty-btn" onclick="chgCartQty(${i},-1)">−</button>
          <span class="qty-val">${item.qty}</span>
          <button class="qty-btn" onclick="chgCartQty(${i},1)">+</button>
        </div>
      </div>
      <div>
        <div class="cart-item-price">${item.price}</div>
        <span class="cart-remove" onclick="removeItem(${i})">Eliminar</span>
      </div>
    </div>
  `).join('');
  const sub = cartItems.length * 16990;
  document.getElementById('sum-sub').textContent = '$' + sub.toLocaleString('es-CL');
  document.getElementById('sum-total').textContent = '$' + (sub + 7000).toLocaleString('es-CL');
}

function chgCartQty(i, d) { 
  cartItems[i].qty = Math.max(1, cartItems[i].qty + d); renderCart(); 
}

function removeItem(i) { 
  cartItems.splice(i, 1); 
  document.getElementById('cart-count').textContent = cartItems.length; renderCart(); 
}

function renderCheckout() {
  const el = document.getElementById('co-items-list');
  if (!el) return;
  el.innerHTML = cartItems.map(item => `
    <div class="co-item">
      <img src="${item.img}" alt="${item.name}">
      <div><div class="co-item-name">${item.name}</div><div class="co-item-sub">Cant. ${item.qty}</div></div>
      <div class="co-item-price">${item.price}</div>
    </div>
  `).join('') || '<p style="font-size:.82rem;color:var(--text3)">Pack Pierna + Pack Mixto (demo)</p>';
  const sub = cartItems.length * 16990 || 35990;
  document.getElementById('co-sub').textContent = '$' + sub.toLocaleString('es-CL');
  document.getElementById('co-total').textContent = '$' + (sub + 7000).toLocaleString('es-CL');
}

function toggleFaq(el) { 
  el.parentElement.classList.toggle('open'); 
}

function setThumb(el, src) {
  el.closest('.pdp-thumbs').querySelectorAll('.pdp-thumb').forEach(t => t.classList.remove('active'));
  el.classList.add('active');
  document.getElementById('pdp-main-img').src = src;
}

function selFmt(el, price) {
  el.closest('.fmt-options').querySelectorAll('.fmt-opt').forEach(o => o.classList.remove('sel'));
  el.classList.add('sel');
  document.getElementById('pdp-price').textContent = price;
}

function selTab(btn, id) {
  btn.closest('.pdp-tabs').querySelectorAll('.pdp-tab-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  btn.closest('.pdp-tabs').querySelectorAll('.pdp-tab-pane').forEach(p => p.classList.remove('active'));
  document.getElementById(id).classList.add('active');
}

function chgQty(d) { 
  pdpQty = Math.max(1, pdpQty + d); 
  document.getElementById('pdp-qty').textContent = pdpQty; 
}

function selDelivery(el) { 
  el.closest('.checkout-block').querySelectorAll('.delivery-opt').forEach(o => o.classList.remove('sel')); 
  el.classList.add('sel'); 
}

function selPay(el) { 
  el.closest('.pay-methods').querySelectorAll('.pay-method').forEach(o => o.classList.remove('sel')); el.classList.add('sel'); 
}

document.querySelectorAll('.format-pill').forEach(p => {
  p.addEventListener('click', function (e) { 
    e.stopPropagation(); 
    this.closest('.prod-format').querySelectorAll('.format-pill').forEach(x => x.classList.remove('sel')); 
    this.classList.add('sel'); 
  });
});

// ===== ANIMACIÓN AL HACER SCROLL =====
(function () {
  function tag(el, dir) { 
    if (el.dataset.reveal) return; 
    el.classList.add('reveal'); 
    if (dir === 'left') el.classList.add('reveal-left'); 
    if (dir === 'right') el.classList.add('reveal-right'); el.dataset.reveal = '1'; 
  }

  // grupos con efecto escalonado
  function tagStagger(selector) {
    const byParent = new Map();
    document.querySelectorAll(selector).forEach(el => { 
      tag(el); 
      const p = el.parentElement; 
      const a = byParent.get(p) || []; 
      a.push(el); byParent.set(p, a); 
    });
    byParent.forEach(arr => arr.forEach((el, i) => { 
      el.style.transitionDelay = Math.min(i * 0.08, 0.48) + 's'; 
    }));
  }

  // hero
  document.querySelectorAll('.hero-copy > *').forEach((el, i) => { 
    tag(el); 
    el.style.transitionDelay = (i * 0.1) + 's'; 
  });
  document.querySelectorAll('.hero-photo').forEach(el => tag(el, 'right'));

  // encabezados de sección, en cascada eyebrow > título > sub
  document.querySelectorAll('.section-inner').forEach(si => {
    let i = 0;
    si.querySelectorAll(':scope > .section-eyebrow, :scope > .section-title, :scope > .section-sub').forEach(el => { 
      tag(el); el.style.transitionDelay = (i++ * 0.09) + 's'; 
    });
  });
  ['.section-eyebrow', '.section-title', '.section-sub', '.related-title', '.related-sub', '.consume-eyebrow', '.consume-title'].forEach(s => document.querySelectorAll(s).forEach(el => tag(el)));

  // producto estrella: mitades entran desde los lados
  document.querySelectorAll('.star-img').forEach(el => tag(el, 'left'));
  document.querySelectorAll('.star-body').forEach(el => tag(el, 'right'));
  
  // tarjetas y bloques repetidos, escalonados
  ['.prod-card', '.pack-card', '.feature', '.faq-item', '.consume-step', '.timeline-item', '.step', '.contact-info-item', '.checkout-block', '.related-card'].forEach(tagStagger);

  const supported = 'IntersectionObserver' in window;
  const io = supported ? new IntersectionObserver(function (entries) 
  {
    entries.forEach(function (e) { 
      if (e.isIntersecting) { 
        e.target.classList.add('is-visible'); 
        io.unobserve(e.target); 
      } 
    });
  }, { 
    threshold: 0.12, rootMargin: '0px 0px -8% 0px' 
  }) : null;

  window.__revealInView = function () {
    document.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
      const r = el.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight * 0.95) { 
        el.classList.add('is-visible'); 
        if (io) io.unobserve(el); 
      }
    });
  };

  if (io) { 
    document.querySelectorAll('.reveal').forEach(el => io.observe(el)); 
  }
  else { 
    document.querySelectorAll('.reveal').forEach(el => el.classList.add('is-visible')); 
  }

  // revelar lo que ya está en pantalla al cargar
  requestAnimationFrame(window.__revealInView);
})();

// Render lucide icons
if (window.lucide) { 
  lucide.createIcons(); 
}

// Re-render cuando se cambia de página
const _origNav = window.nav;
window.nav = function (id) { 
  _origNav(id); 
  closeMenu(); 
  setTimeout(() => { 
    if (window.lucide) lucide.createIcons(); 
    if (window.__revealInView) window.__revealInView(); 
  }, 60
); 
};

// hidratar imagenes embebidas
(function () 
{
  function h() { 
    document.querySelectorAll('img[data-imgkey]').forEach(function (im) { 
      var k = im.getAttribute('data-imgkey'); 
      if (window.IMG && window.IMG[k] && im.src !== window.IMG[k]) im.src = window.IMG[k]; 
    }); 
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', h); 
  else h();
})();


let productQty = 1;
let currentVariantPrice = 0;

document.addEventListener("DOMContentLoaded", function () {

    const priceBox = document.getElementById("pdp-price");

    if (priceBox) {
        currentVariantPrice = parseInt(priceBox.dataset.price || 0);
    }

    updateProductPrice();
});


function formatMoney(cents) {

    return new Intl.NumberFormat("es-CL", {
        style: "currency",
        currency: "CLP",
        minimumFractionDigits: 0
    }).format(cents / 100);

}

function changeMedia(el) {

    document.querySelectorAll('.pdp-thumb').forEach(t=>{
        t.classList.remove('active');
    });

    el.classList.add('active');

    let type = el.dataset.type;

    let wrapper = document.getElementById('pdp-main-media');

    if(type === 'image'){

        wrapper.innerHTML = `
            <img
                id="pdp-main-img"
                src="${el.dataset.src}"
                alt=""
            >
        `;

    }else if(type === 'video'){

        wrapper.innerHTML = `
            <video
                controls
                autoplay
                playsinline
                width="100%">
                <source src="${el.dataset.video}" type="video/mp4">
            </video>
        `;

    }

}


/**************** PDP Qty JS *******************/

window.changeQty = function (change) {

    productQty += change;

    if (productQty < 1) {
        productQty = 1;
    }

    document.getElementById("qty-value").textContent = productQty;
    document.getElementById("qty-input").value = productQty;

    updateProductPrice();

}

window.selectVariant = function (el) {

    document.querySelectorAll(".fmt-opt").forEach(function (btn) {
        btn.classList.remove("sel");
    });

    el.classList.add("sel");

    currentVariantPrice = parseInt(el.dataset.price);

    document.getElementById("variant-id").value = el.dataset.id;

    updateProductPrice();

}
function updateProductPrice() {

    const priceEl = document.getElementById("pdp-price");

    if (!priceEl) return;

    priceEl.innerHTML = formatMoney(currentVariantPrice * productQty);

}